module.exports = __webpack_public_path__ + "img/formbg.4ea8c5ed.png";